import React from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";

const PaySuccess = () => {
  const [params] = useSearchParams();
  const success = params.get("state") === "success";
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${success ? "" : "cancelled"}`}>
              <FontAwesomeIcon icon={success ? faCheck : faXmark} />
              <div className="checkmark"></div>
            </div>
            <h2>{success ? "Payment received" : "Payment cancelled"}</h2>
            <p>{success ? "Thank you. Your order is being confirmed and a receipt will be sent to your email." : "No payment was completed. Your cart is still available if you would like to try again."}</p>
            <Link to={success ? "/shop" : "/checkout"}>{success ? "Continue shopping" : "Return to checkout"}</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
